module.exports = __webpack_public_path__ + "static/img/yytx35.206a1ef.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx35.png
// module id = 902
// module chunks = 0